/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoicesempty1Inputs */

const en_invoicesempty1 = /** @type {(inputs: Invoicesempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your invoices appear here once you buy something.`)
};

const de_invoicesempty1 = /** @type {(inputs: Invoicesempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier stehen deine Rechnungen, sobald du etwas kaufst.`)
};

/**
* | output |
* | --- |
* | "Your invoices appear here once you buy something." |
*
* @param {Invoicesempty1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invoicesempty1 = /** @type {((inputs?: Invoicesempty1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoicesempty1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invoicesempty1(inputs)
	return de_invoicesempty1(inputs)
});
export { invoicesempty1 as "invoicesEmpty" }